// extracted by mini-css-extract-plugin
export default {"add-attachments-rp-supporting-document-button":"AddAttachmentsRPSupportingDocumentButton_add-attachments-rp-supporting-document-button__QkyHh"};